// hooks/useProductCourierRules.ts — ambil aturan kurir produk by productId (null = tanpa batasan)
import { useEffect, useState } from 'react';
import { fetchProductCourierRules, type ProductCourierRules } from '../services/productCourierRules';

export function useProductCourierRules(productId?: string | null): ProductCourierRules | null {
  return useProductCourierRulesState(productId).rules;
}

// Varian dengan status loading — untuk menutup race "pilih kurir sebelum aturan
// tiba" (insiden SiCepat #88dcc01c, 2026-10-03): selama productId diketahui tapi
// rules belum resolve, caller WAJIB menahan daftar/pilihan (loading=true),
// bukan menganggap tidak ada blokir.
export function useProductCourierRulesState(productId?: string | null): { rules: ProductCourierRules | null; loading: boolean } {
  const [rules, setRules] = useState<ProductCourierRules | null>(null);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    let alive = true;
    setRules(null);
    if (!productId) { setLoading(false); return; }
    setLoading(true);
    fetchProductCourierRules(productId)
      .then(r => { if (alive) { setRules(r); setLoading(false); } })
      .catch(() => { if (alive) setLoading(false); });
    return () => { alive = false; };
  }, [productId]);
  return { rules, loading };
}
